export default function ReviewSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          <div className="lg:w-3/5 flex flex-col justify-center">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-2.5 h-2.5 rounded-full bg-foreground-900"></span>
              <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider">Editorial Review</span>
            </div>
            <blockquote className="text-xl md:text-2xl lg:text-3xl font-heading font-medium text-foreground-950 leading-relaxed mb-6">
              &ldquo;Hipobuy Sheet revolutionizes how we organize global product sourcing. It is the most comprehensive spreadsheet directory for European and American shoppers.&rdquo;
            </blockquote>
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-foreground-800">Hipobuy Editorial Team</span>
              <span className="w-4 h-4 rounded-full bg-secondary-400 flex items-center justify-center">
                <i className="ri-check-line text-[10px] text-background-50"></i>
              </span>
              <span className="text-xs text-foreground-500">Verified Resource</span>
            </div>
          </div>
          <div className="lg:w-2/5">
            <div className="relative rounded-lg overflow-hidden h-72 md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20photography%20of%20minimal%20home%20office%20corner%20with%20laptop%20open%20notebook%20and%20warm%20table%20lamp%2C%20textured%20linen%20curtains%2C%20beige%20and%20oatmeal%20color%20palette%2C%20soft%20evening%20ambient%20light%2C%20professional%20creative%20workspace%20aesthetic%2C%20cozy%20atmosphere&width=700&height=900&seq=review-portrait-v4&orientation=portrait"
                alt="Hipobuy Spreadsheet editorial workspace"
                title="Hipobuy Spreadsheet Editorial Review"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}